
import { Box, Button, ButtonGroup, MenuItem, TextField } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import ComboBox from 'components/ComboBox'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import React, { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import { initFilterData, clearFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { tyreApiNm } from './constant'
import AddButton from 'components/buttons/AddButton'
import TyreDialog from './TyreDialog'
import TyreSizeDialog from './TyreSizeDialog'
import AddTyreBulkDialog from './AddTyreBulkDialog'
import { tyreColumns } from './columns'
import { SettingsRounded, ViewListRounded } from 'resource/muiImport'

let selectedId = null
let lastFilter = null

const TyreManagement = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [sizeDialogOpen, setSizeDialogOpen] = useState(false)
  const [bulkDialogOpen, setBulkDialogOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [tyreSizeCombo, setTyreSizeCombo] = useState([])

  const loadTyreSizes = useCallback(() => {
    ax.post(tyreApiNm.getTyreSize, {}).then(value => {
      if (value.data) {
        setTyreSizeCombo(value.data.map(s => ({ id: s.TyrSzId, label: s.TyrSzNm })))
      }
    })
  }, [ax])

  const getData = useCallback((filter) => {
    ax.post(tyreApiNm.getTyre, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'TyrId'))
        lastFilter = filter
      }
    })
  }, [ax])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'ShowDetail') {
      selectedId = params.id
      setDialogOpen(true)
    }
  }, [])

  const handleRowDoubleClick = useCallback((params) => {
    selectedId = params.id
    setDialogOpen(true)
  }, [])

  const onFinish = useCallback(() => {
    getData(lastFilter)
  }, [getData])

  const handleAdd = useCallback(() => {
    selectedId = null
    setDialogOpen(true)
  }, [])

  const handleAddBulk = useCallback(() => {
    setBulkDialogOpen(true)
  }, [])
  useEffect(() => {
    getData({ ...initFilterData })
    loadTyreSizes()
  }, [getData, loadTyreSizes])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <ButtonGroup>
          <AddButton onClick={handleAdd}>เพิ่มยาง</AddButton>
          <Button variant="contained" onClick={handleAddBulk}><ViewListRounded /></Button>
        </ButtonGroup>
        <Button variant="contained" startIcon={<SettingsRounded />} onClick={() => setSizeDialogOpen(true)}>
          ขนาดยาง
        </Button>
        <Box flex={1} />
        <TextField size="small" label="รหัสยาง" sx={{ width: 150 }}
          value={filterData.TyrCd ?? ""}
          onChange={(e) => setFilterData(o => ({ ...o, TyrCd: e.target.value || null }))} />
        <TextField size="small" label="ยี่ห้อ" sx={{ width: 150 }}
          value={filterData.TyrBrand ?? ""}
          onChange={(e) => setFilterData(o => ({ ...o, TyrBrand: e.target.value || null }))} />
        <ComboBox
          options={tyreSizeCombo}
          label="ขนาด"
          selectedId={filterData.TyrSzId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TyrSzId: id }))}
          sx={{ width: 150 }}
        />
        <TextField size="small" label="สถานะ" select sx={{ width: 100 }}
          value={filterData.TyrStsId ?? ""}
          onChange={(e) => setFilterData(o => ({ ...o, TyrStsId: e.target.value || null }))}>
          <MenuItem value="">ทั้งหมด</MenuItem>
          <MenuItem value={1}>ในสต็อก</MenuItem>
          <MenuItem value={2}>ติดตั้ง</MenuItem>
          <MenuItem value={3}>หล่อดอก</MenuItem>
          <MenuItem value={4}>จำหน่าย</MenuItem>
        </TextField>
        <ComboBox
          options={msData.truckCombo || []}
          label="รถ"
          selectedId={filterData.TukId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TukId: id }))}
          sx={{ width: 150 }}
        />
        <ComboBox
          options={msData.trailerCombo || []}
          label="หางพ่วง"
          selectedId={filterData.TlrId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TlrId: id }))}
          sx={{ width: 150 }}
        />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
      </BoxFR>
      <Box height='100%'>
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={tyreColumns}
          onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <TyreDialog
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        onFinish={onFinish}
        tyreSizeCombo={tyreSizeCombo}
      />
      <TyreSizeDialog
        dialogOpen={sizeDialogOpen}
        setDialogOpen={setSizeDialogOpen}
        onFinish={loadTyreSizes}
      />
      <AddTyreBulkDialog
        dialogOpen={bulkDialogOpen}
        setDialogOpen={setBulkDialogOpen}
        onFinish={onFinish}
        tyreSizeCombo={tyreSizeCombo}
      />
    </BoxFC>
  )
}

export default TyreManagement
